import { TriangleDownIcon } from '@chakra-ui/icons'
import {
  Box,
  Flex,
  Image as ChakraImage,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  useDisclosure
} from '@chakra-ui/react'
import Image from 'next/image'
import { Media } from 'types/global'
interface ReviewMediaProps {
  media: Media
}

const ReviewMedia: React.FC<ReviewMediaProps> = ({ media }) => {
  const isImage = media.media_type === 'image'
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <>
      <Flex
        alignItems="center"
        justifyContent="center"
        cursor="pointer"
        _hover={{ transform: 'translateY(-4px)' }}
        transition="transform 300ms"
        onClick={onOpen}
      >
        <Box width="150px" height="150px" position="relative">
          {isImage && (
            <Image
              src={media.url}
              alt="Uploaded Image"
              height={150}
              width={150}
              className="object-cover w-full h-full"
            />
          )}
          {!isImage && (
            <Flex position="relative" className="group">
              <Box
                position="absolute"
                top="50%"
                left="50%"
                transform="translate(-50%, -50%)"
              >
                <TriangleDownIcon
                  color="white"
                  w={8}
                  h={8}
                  className="transition transform -rotate-90 group-hover:scale-125"
                />
              </Box>
              <video src={media.url} className="object-cover w-full h-full" />
            </Flex>
          )}
        </Box>
      </Flex>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody
            display="flex"
            justifyContent="center"
            alignItems="center"
            p={8}
          >
            {isImage && (
              <ChakraImage
                src={media.url}
                alt="Uploaded Image"
                h="100%"
                w="100%"
              />
            )}
            {!isImage && <video src={media.url} width="100%" controls />}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ReviewMedia
